import React from 'react';
import PropTypes from 'prop-types';

import {
  Grid,
  Typography,
  makeStyles,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  DialogContentText,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  modal: {
    fontSize: '20px',
    borderRadius: '15px',
  },
  title: theme.title,
  contentLabel: {
    fontSize: '18px',
  },
}));
const ErrorDialog = ({
  content,
  title,
  handleCloseError,
  handleClearTotal,
}) => {
  const classes = useStyles();
  return (
    <Dialog className={classes.modal} open={true} onClose={handleCloseError}>
      <DialogTitle id="alert-dialog-title">
        <Typography className={classes.title}>{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Typography className={classes.contentLabel}>{content}</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClearTotal} color="secondary">
          Effacer
        </Button>
        <Button onClick={handleCloseError} color="secondary" autoFocus>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ErrorDialog.propTypes = {};

export default ErrorDialog;
